import React, { Fragment, useState } from "react";
import { Helmet } from "react-helmet";
import CommonFrom from "../../../Common/Components/Form";
import { FormSubmit, Gettags } from "./Components/Services";
function Create() {
  const initialState = {
    loading: false,
  };
  const [state, setstate] = useState(initialState);

  const Handler = data => {
    setstate({ loading: true });
    FormSubmit({ ...data, tag_id: data.tag_id.map(tag => tag.value) }).then(
      () => {
        setstate({
          loading: false,
        });
      }
    );
  };
  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | ثبت مقاله</title>
      </Helmet>
      <CommonFrom
        form={input}
        loading={state.loading}
        header="ایجاد مقاله"
        textbtn="لیست مقالات"
        linkbtn="/Admin/blog/List"
        btnName="ایجاد مقاله"
        submit={Handler}
        nested={["tags", "blogcategory"]}
        textEditor={"content"}
      />
    </Fragment>
  );
}

export const input = [
  {
    label: "عنوان مقاله",
    size: "col-md-6",
    classNames: "mt-2",
    placeholder: "",
    name: "title",
    value: "",
  },
  {
    label: "انتخاب تگ ها",
    size: "col-md-3",
    classNames: "mt-2",
    placeholder: "",
    name: "tag_id",
    input: "selectTable",
    multiple: true,
    nested: "tags",
  },
  {
    label: "انتخاب دسته بندی",
    size: "col-md-3",
    classNames: "mt-2",
    placeholder: "",
    name: "category_id",
    input: "select",
    nested: "blogcategory",
  },
  {
    label: "توضیحات",
    size: "col-md-12",
    classNames: "mt-2",
    placeholder: "",
    name: "description",
    input: "textarea",
  },
  {
    label: "متن مقاله",
    size: "col-md-12",
    classNames: "mt-2",
    placeholder: "",
    name: "content",
    input: "ckeditor",
  },
  {
    label: "کد اسکیما",
    size: "col-md-12",
    classNames: "mt-4",
    placeholder: "",
    value: "",
    name: "seo",
    keyname: "seoSchema",
    noNeed: true
  },
  {
    label: "کلمات کلیدی سئو",
    size: "col-md-4",
    classNames: "mt-2",
    placeholder: "",
    name: "seo",
    keyname: "seoKeyword",
    value: "",
    input: "textarea",
  },
  {
    label: "توضیحات کلیدی سئو",
    size: "col-md-4",
    classNames: "mt-2",
    placeholder: "",
    name: "seo",
    keyname: "seoDescription",
    value: "",
    input: "textarea",
  },
  {
    label: "تصویر مقاله",
    size: "col-md-4",
    classNames: "mt-2",
    placeholder: "",
    name: "image",
    input: "file",
    alt: true,
    accept: "image/png, image/jpeg",
  },
];

export default Create;
